export default __webpack_public_path__ + "static/media/lactation-res.61b2761f.svg";